import React from 'react';
import PropTypes from 'prop-types';
import { LogoFull } from '../../assets/icons';
import './AuthForm.scss';

const AuthForm = (props) => {
  return (
    <div className={props.className ? `auth__form ${props.className} ` : 'auth__form'}>
      <div className='auth__form__header'>
        <div className='header__logo'>
          <LogoFull verticalAlign='middle'/>
        </div>
        {props.note && <div className='header__note'>{props.note}</div>}
      </div>
      <div className='auth__form__body'>
        {props.title && <h3 className='auth__form__title'>{props.title}</h3>}
        {props.description && <div className='auth__form__description'>{props.description}</div>}
        {props.children}
      </div>
    </div>
  );
};

AuthForm.propTypes = {
  className: PropTypes.string,
  note: PropTypes.element,
  title: PropTypes.element,
  description: PropTypes.element,
  children: PropTypes.any,
};

export default AuthForm;
